import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=0f6b2c57&scoped=true"
import script from "./PasswordForm.vue?vue&type=script&lang=ts"
export * from "./PasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./PasswordForm.vue?vue&type=style&index=0&id=0f6b2c57&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b2c57",
  null
  
)

export default component.exports